import { ButtonPrimeReact } from "@finanedi.es/storybook"
import {
  getContactoPreferenciasById,
  getContactosById,
} from "api/Contacto.service"
import { ContactoConfiguracionReadingDtoProps } from "api/DTOs/ContactoConfiguracionReadingDto"
import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import Modal from "common/components/Modal/Modal"
import SwitchBtns from "features/Crear/components/SwitchBtns"
import { capitalize } from "features/User/utils"
import { useSelector } from "hooks/useSelector"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { InputSwitch } from "primereact/inputswitch"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { globalSelector } from "routes/globalSlice"
import { FormikDocumentsProps } from "../../CreacionDocumento"
import { EmpresaActivaDocProps } from "../../FormCreacionDocumento"
import {
  MODES_DOCUMENTOS,
  getDocumentLabel,
  handleOnHideCrearDocumento,
} from "../../constant"
import { FormasPago } from "../../hooks/ConvertirDocumento/ConvertirDocumento"
import DropdownContactos from "../DropdownContactos/DropdownContactos"

const ModalSelectContactDocumento = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const history = useHistory()

  const { activeCompany } = useUsuarioEmpresaActiva()
  const { usuarioByCurrent } = useUsuarioByCurrent()
  const { formasPago } = useSelector(globalSelector)

  const addPreferences = ({
    descuento,
    diaDePago,
    formaPago,
    vencimientoDias,
  }: ContactoConfiguracionReadingDtoProps) => {
    const fechaVencimientoDate = new Date(values.fechaVencimiento)
    if (vencimientoDias) {
      fechaVencimientoDate.setDate(
        fechaVencimientoDate.getDate() + vencimientoDias
      )
    }

    const nuevaFechaVencimiento = fechaVencimientoDate.toISOString()
    if (values.documentoType.mode === MODES_DOCUMENTOS.VENTA) {
      if (descuento) setFieldValue("descuento", descuento)
      if (diaDePago) setFieldValue("diasPago", diaDePago)
      if (formaPago) {
        const formaPagoDescription = formasPago?.find(
          (forma: FormasPago) => formaPago === forma.id
        )?.description

        setFieldValue("formaPago", formaPago)
        setFieldValue("formaPagoDescription", formaPagoDescription)
      }
      if (vencimientoDias)
        setFieldValue("fechaVencimiento", nuevaFechaVencimiento)
    }
  }

  const handleContacto = async ({ value }: { value: string }) => {
    const isVenta = values.documentoType.mode === MODES_DOCUMENTOS.VENTA

    setFieldValue(isVenta ? "librado.id" : "librador.id", value)

    const dataContact: ContactoReadingDtoProps = await getContactosById(value)
    setFieldValue(isVenta ? "librado" : "librador", {
      id: value,
      ...dataContact,
      telefono: dataContact?.telefonos?.[0]?.contacto,
      email: dataContact?.emails?.[0]?.contacto,
    })

    const dataContactPreferences = await getContactoPreferenciasById(value)
    setFieldValue("config.preferenceContat", dataContactPreferences)
    addPreferences(dataContactPreferences)

    const empresaActiva = usuarioByCurrent?.empresaActiva

    const fieldValue: EmpresaActivaDocProps = {
      id: activeCompany?.id,
      ...(empresaActiva !== undefined && { ...empresaActiva }),
    }

    setFieldValue(isVenta ? "librador" : "librado", fieldValue)
  }

  const handleSwithMode = (position: string) => {
    const isCompra = position === MODES_DOCUMENTOS.COMPRA
    setFieldValue("documentoType.mode", position)
    setFieldValue("config.esCompraArticulos", isCompra)
    isCompra && setFieldValue("serie", null)
    setFieldValue("librado", null)
    setFieldValue("librador", null)
  }

  const submitFirstPart = () => {
    setFieldValue("documentoType.screen", 2)
  }

  return (
    <Modal
      header={`${t("crear.documento.create")} ${getDocumentLabel(
        values.documentoType.type,
        t
      )}`}
      size='small'
      backdrop={false}
      maskClassName='!tw-z-40'
      onHide={() =>
        history.push(handleOnHideCrearDocumento(values.documentoType.type))
      }
      draggable
      className='!tw-rounded-lg'
      visible={values.documentoType?.screen === 1}
    >
      <div className='tw-flex tw-flex-col tw-items-start'>
        <p className='tw-m-0 tw-font-normal tw-mb-4'>
          {t("newDoc.presupuesto.selectTypeDocLabel")}
        </p>
        <SwitchBtns
          labelRight={t("crear.documento.compra")}
          labelLeft={t("crear.documento.venta")}
          onClickRight={() => handleSwithMode(MODES_DOCUMENTOS.COMPRA)}
          onClickLeft={() => handleSwithMode(MODES_DOCUMENTOS.VENTA)}
          leftActive={values.documentoType.mode === MODES_DOCUMENTOS.VENTA}
        />
        <p className='tw-m-0 tw-mt-6 tw-mb-2'>
          {values.documentoType.mode === MODES_DOCUMENTOS.VENTA
            ? `${t("crear.documento.cliente")}`
            : `${t("crear.documento.proveedor")}`}
        </p>

        <DropdownContactos
          values={values}
          setFieldValue={setFieldValue}
          onchange={handleContacto}
        />

        <div className='tw-flex tw-items-center tw-my-6 '>
          <InputSwitch
            checked={values.config.sinValorar}
            onChange={() =>
              setFieldValue("config.sinValorar", !values.config.sinValorar)
            }
            className='tw-cursor-pointer tw-mr-2'
          />
          <span>
            {capitalize(getDocumentLabel(values.documentoType.type, t))}{" "}
            {t("crear.documento.notValorate")}
          </span>
        </div>
        <ButtonPrimeReact
          className='tw-h-14 tw-w-full tw-flex tw-justify-center tw-items-center tw-rounded tw-cursor-pointer !tw-bg-primary !tw-text-simple-10'
          type='submit'
          onClick={() => submitFirstPart()}
          disabled={
            values?.documentoType?.mode === MODES_DOCUMENTOS.VENTA
              ? !values?.librado?.id
              : !values?.librador?.id
          }
        >
          {t("crear.documento.start")}{" "}
          {getDocumentLabel(values?.documentoType?.type, t)}
        </ButtonPrimeReact>
      </div>
    </Modal>
  )
}

export default ModalSelectContactDocumento
